import { CommandStatus } from "./command.types";

export enum ActivityLogType {
  CHANGE_STATUS = "CHANGE_STATUS",
  HISTORY = "HISTORY",
  UPDATE = "UPDATE",
}

export type ActivityLogChangeStatusMeta = {
  from?: CommandStatus
  to?: CommandStatus
  next?: CommandStatus
  prev?: CommandStatus
}

export type ActivityLogHistoryMeta = {
  type: string
}

export type ActivityLog = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  type: string;
  meta: object;
  user: {
    firstName: string;
    lastName: string;
  };
};